import { useContext } from 'react';
/* CONTEXT */
import { CommonContext, NotificationsContext } from 'components/AuthenticatedApp/AuthenticatedApp';
import NotificationsPanel from './NotificationsPanel';
/* HOOK */
import { useWindowSize } from '@solinkcorp/solink-components';
import { useColorTheme } from 'src/hooks/useColorTheme';
import useLocale from 'src/hooks/useLocale';

const PushNotifications = (props) => {
  const { loading } = useContext(NotificationsContext);
  const { width } = useWindowSize();
  const {
    authData: { isImpersonating },
  } = useContext(CommonContext);
  const locale = useLocale();
  // The classic panel forces dark on the video tab. This page follows the app theme.
  const { isDark: useDarkTheme } = useColorTheme();

  return (
    <NotificationsPanel
      {...props}
      useDarkTheme={useDarkTheme}
      isImpersonating={isImpersonating}
      isLoading={loading}
      locale={locale}
      windowWidth={width}
    />
  );
};

export default PushNotifications;
